import type { QueryMeta } from '../fetch/types';
import isNative from '../native/isNative';
import { getDomain as getBaseDomain } from '../native/localStorage';

export default function getDomain(queryMeta?: QueryMeta) {
  if (isNative()) {
    return queryMeta?.apiDomain ?? getBaseDomain();
  }

  if (typeof window === 'undefined') {
    return undefined;
  }
  return (
    //   eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- just to make sure that the value is not undefined
    queryMeta?.apiDomain ??
    (window as { __unifyBaseUrl?: string }).__unifyBaseUrl ??
    window.location.origin
  );
}
